import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import fileModule from './modules/file';
import language from './modules/language';
import cname from './modules/cname';
import list from './modules/list';
import app from './modules/app';
import url from './modules/url';
import AssetId from './modules/AssetId';
import service from './modules/service';
import tag from './modules/tag';
import thumbnail from './modules/thumbnail';
import DialogClose from './modules/DialogClose';
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    count: 0,
    encodingResults: [],
    failedIndexes: [],
    loading: false,
  },
  getters: {
    getCount(state) {
      return state.count
    }
  },
  mutations: {
    increment(state) {
      state.count++
    },
    decrement(state) {
      state.count--
    },
    SET_ENCODING_RESULT(state, result) {
      state.encodingResults.push(result);
    },
    SET_FAILED_INDEX(state, index) {
      state.failedIndexes.push(index);
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
  },
  actions: {
    increment(context) {
      context.commit('increment')
    },
    decrement(context) {
      context.commit('decrement')
    },
    // async submitForm({ commit }, { formData, token, i }) {
    //   try {
    //        for (let value of formData.values()) {
    //                     console.log("[formData22]", value);
    //                 }
    //     const res = await axios.post(process.env.VUE_APP_SEND_ENCODING+'/yj3.php', formData, {
    //       headers: {
    //         'Authorization': `Bearer ${token}`,
    //         'Content-Type': 'multipart/form-data',
    //       },
    //       timeout: 300000,
    //     });
    //     console.log("인코딩3 : ", res);
    //     commit('SET_ENCODING_RESULT', res);
    //   } catch (error) {
    //     console.log("[인코딩3 error]", error);
    //     commit('SET_FAILED_INDEX', i);
    //   }
    // },
    setLoading(context, loading) {
      context.commit('setLoading', loading);
    },
  },
  modules: {
    cname,
    language,
    user,
    list,
    app,
    url,
    AssetId,
    service,
    tag,
    thumbnail,
    DialogClose,
    file: fileModule,
  }
})
